import Cookies from 'universal-cookie';
// import { useQuery } from 'react-query';
const cookies = new Cookies()

export function getLoginDeviceInfo() {
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    return {
        systemDetail: isMobile ? "Mobile" : "Browser",
        browser_detail: navigator.userAgent || "",
    };
}

export function readLoginFields(
    e: any,
    fallback: { username?: string; user_name?: string; password?: string } = {}
) {
    const target = e?.currentTarget || e?.target;
    const root: ParentNode | Document =
        (target instanceof HTMLFormElement && target) ||
        target?.closest?.("form") ||
        target?.closest?.(".login-wrap") ||
        target?.closest?.(".login_form") ||
        target?.closest?.(".login_form_main") ||
        target?.closest?.(".form-info") ||
        target?.closest?.(".w-60") ||
        target?.closest?.(".login_main") ||
        document;
    const valueOf = (name: string) => {
        const el = root.querySelector?.(`[name="${name}"]`) as HTMLInputElement | null;
        return el && typeof el.value === "string" ? el.value : "";
    };
    const username = String(
        valueOf("user_name") ||
            valueOf("username") ||
            fallback.user_name ||
            fallback.username ||
            ""
    ).trim();
    const password = String(valueOf("password") || fallback.password || "");
    return { username, password };
}

export const AUTH_COOKIE_MAX_AGE_SEC = 10 * 60 * 60;
export const IDLE_LOGOUT_MS = 30 * 60 * 1000;
export const SESSION_EXPIRED_MSG = "Session expired. Please log in again.";
export const SESSION_EXPIRED_EVENT = "sky:session-expired";
const LAST_ACTIVITY_KEY = "skyLastActivityAt";

export const getLastActivityAt = () => {
    try {
        const ts = Number(localStorage.getItem(LAST_ACTIVITY_KEY));
        return Number.isFinite(ts) && ts > 0 ? ts : 0;
    } catch {
        return 0;
    }
};

export const touchLastActivity = () => {
    try {
        localStorage.setItem(LAST_ACTIVITY_KEY, String(Date.now()));
    } catch {
        // ignore storage errors (private mode, etc.)
    }
};

export const clearLastActivity = () => {
    try {
        localStorage.removeItem(LAST_ACTIVITY_KEY);
    } catch {
        // ignore
    }
};

export const isIdlePastTimeout = (idleMs = IDLE_LOGOUT_MS) => {
    const last = getLastActivityAt();
    if (!last) return false;
    return Date.now() - last >= idleMs;
};

/** Silent logout when the 30-minute idle window already elapsed (closed tab, sleep, etc.). */
export const consumeIdleSessionIfNeeded = () => {
    if (typeof window === "undefined") return false;
    if (!cookies.get("skyTokenFront")) return false;
    const last = getLastActivityAt();
    if (!last) {
        touchLastActivity();
        return false;
    }
    if (Date.now() - last < IDLE_LOGOUT_MS) return false;
    markIdleLogoutHome();
    Logout();
    window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
    return true;
};

export const setAuthCookie = (token: string) => {
    cookies.set("skyTokenFront", token, {
        domain: process.env.REACT_APP_COOKIE_DOMAIN,
        path: "/",
        maxAge: AUTH_COOKIE_MAX_AGE_SEC,
    });
    touchLastActivity();
};

export const Logout = (e: any = null) => {
    if (e) e.preventDefault()
    const cookieDomain = process.env.REACT_APP_COOKIE_DOMAIN || undefined;
    const expire = "Thu, 01 Jan 1970 00:00:01 GMT";
    document.cookie = `skyTokenFront=; Path=/; Expires=${expire}; Max-Age=0`;
    document.cookie = `skyTokenFront=; Path=/; Expires=${expire}; Max-Age=0; SameSite=Lax`;
    if (cookieDomain) {
        document.cookie = `skyTokenFront=; Path=/; Domain=${cookieDomain}; Expires=${expire}; Max-Age=0`;
        cookies.remove("skyTokenFront", { domain: cookieDomain, path: "/" });
    }
    cookies.remove("skyTokenFront", { path: "/" });
    cookies.remove("skyTokenFront");
    clearLastActivity();
};

const IDLE_LOGOUT_HOME_KEY = "skyIdleLogoutHome";
const IDLE_LOGOUT_HOME_MAX_AGE_MS = 8000;

export const markIdleLogoutHome = () => {
    try {
        sessionStorage.setItem(IDLE_LOGOUT_HOME_KEY, String(Date.now()));
    } catch {
        // ignore storage errors (private mode, etc.)
    }
};

export const isIdleLogoutHome = () => {
    try {
        const raw = sessionStorage.getItem(IDLE_LOGOUT_HOME_KEY);
        if (!raw) return false;
        const ts = Number(raw);
        if (!Number.isFinite(ts) || Date.now() - ts > IDLE_LOGOUT_HOME_MAX_AGE_MS) {
            sessionStorage.removeItem(IDLE_LOGOUT_HOME_KEY);
            return false;
        }
        return true;
    } catch {
        return false;
    }
};

export const consumeIdleLogoutHome = () => {
    if (!isIdleLogoutHome()) return false;
    try {
        sessionStorage.removeItem(IDLE_LOGOUT_HOME_KEY);
    } catch {
        // ignore
    }
    return true;
};

// export const getImageUrl = (path: String) => {
//     let link = `https://jitbo.site/uploads/` + path;
//     // link = (process.env.REACT_APP_BASE_POINT ? process.env.REACT_APP_BASE_POINT : '') + path // comment before push code

//     // const { data: imageSrc, isLoading } = useQuery('image', link);
//     const img = new Image();
//     img.src = link;
//     // img.onload = function() {
//     //     console.log('Image is available');
//     // };
//     // img.onerror = ()=>{
//     //     console.log('Image is not available');
//     //     link = (process.env.REACT_APP_BASE_POINT ? process.env.REACT_APP_BASE_POINT : '') + path
//     // }
//     // try {
//     //     link = require(`${link}`);
//     // } catch (err) {

//     //    }

//     return link;
// }

// export const getImageUrl = (path: String) => {
//     // let link = `https://${window.location.hostname}/uploads/` + path;
//        let link = (process.env.REACT_APP_BASE_POINT ? process.env.REACT_APP_BASE_POINT : '') + path // comment before push code

//         // const { data: imageSrc, isLoading } = useQuery('image', link);
//     const img = new Image();
//     img.src = link;
//     // img.onload = function() {
//     //     console.log('Image is available');
//     // };
//     // img.onerror = ()=>{
//     //     console.log('Image is not available');
//     //     link = (process.env.REACT_APP_BASE_POINT ? process.env.REACT_APP_BASE_POINT : '') + path
//     // }
//     // try {
//     //     link = require(`${link}`);
//     // } catch (err) {
        
//     //    }
    
//     return link;
// }

export const getImageUrl = (path?: string | null) => {
  if (!path) return "";

  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  return `${process.env.REACT_APP_BASE_POINT || ""}/${path}`; 
};

const FAVICON_CACHE_KEY = "site-favicon";

const isUploadedIcon = (href: string) => /^https?:\/\//i.test(href);

const rememberFavicon = (href: string) => {
    try {
        localStorage.setItem(
            FAVICON_CACHE_KEY,
            JSON.stringify({ host: window.location.hostname, href }),
        );
    } catch {
        return;
    }
};

const readCachedFavicon = () => {
    try {
        const data = JSON.parse(localStorage.getItem(FAVICON_CACHE_KEY) || "");
        if (!data || data.host !== window.location.hostname) return "";
        const href = String(data.href || "");
        return isUploadedIcon(href) ? href : "";
    } catch {
        return "";
    }
};

const upsertIconLink = (id: string, rel: string, href: string) => {
    let link = document.getElementById(id) as HTMLLinkElement | null;
    if (!link) {
        link = document.createElement("link");
        link.id = id;
        document.head.appendChild(link);
    }
    link.rel = rel;
    link.removeAttribute("sizes");
    link.removeAttribute("type");
    if (link.getAttribute("href") !== href) {
        link.setAttribute("href", href);
    }
};

/** Use the uploaded file unchanged. No placeholder artwork and no resize. */
export const applySiteFavicon = (domainDetails?: any) => {
    if (typeof document === "undefined") return;
    const uploaded =
        domainDetails?.favicon && String(domainDetails.favicon).trim()
            ? getImageUrl(String(domainDetails.favicon).trim())
            : "";
    const href = isUploadedIcon(uploaded) ? uploaded : readCachedFavicon();
    if (!href) return;
    rememberFavicon(href);
    upsertIconLink("site-favicon", "icon", href);
    upsertIconLink("site-apple-touch-icon", "apple-touch-icon", href);
};

export const showTvIcon = (item: { tv_status?: string | number | null }) => {
    const tvStatus = item?.tv_status;
    return tvStatus !== undefined && tvStatus !== null && String(tvStatus) !== "" && String(tvStatus) !== "0";
}

export const getBetTable = (TABLE: string) => {
    switch (TABLE) {
        case 'odds':
            return 't1';
        case 'bookMark':
            return 't2';
        case 'session':
            return 't3';
        case 'premium':
            return 't4';
        default:
            break;
    }
}


export function descendingComparator(a: { [x: string]: number; }, b: { [x: string]: number; }, orderBy: string | number) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

export function getComparator(order: string, orderBy: any) {
    return order === 'desc'
        ? (a: any, b: any) => descendingComparator(a, b, orderBy)
        : (a: any, b: any) => -descendingComparator(a, b, orderBy);
}

export function stableSort(array: any[], comparator: (arg0: any, arg1: any) => any) {
    const stabilizedThis = array.map((el: any, index: any) => [el, index]);
    stabilizedThis.sort((a: number[], b: number[]) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el: any[]) => el[0]);
}

export const getDomain = () => {
    return window.location.hostname === "localhost"
        ? (process.env.REACT_APP_DOMAIN || "jitbo.site")
        : window.location.hostname;
}

export const isMobileHeaderView = () => {
    if (typeof window === "undefined") return false
    const inner = window.innerWidth || 0
    const screenW = window.screen?.width || 0
    const visual = window.visualViewport?.width || 0
    const widths = [inner, screenW, visual].filter((n) => n > 0)
    const minW = widths.length ? Math.min(...widths) : inner
    return minW <= 768
}

export const getSiteLogo = (site?: { logo?: string; mobileLogo?: string }) => {
    if (isMobileHeaderView() && site?.mobileLogo) {
        return site.mobileLogo
    }
    return site?.logo || ""
}

export const getSiteHeaderSchema = (site?: { headerSchema?: string; mobileHeaderSchema?: string }) => {
    if (isMobileHeaderView() && site?.mobileHeaderSchema) {
        return site.mobileHeaderSchema
    }
    return site?.headerSchema || ""
}

/**
 * Captcha visibility — safe for existing sites:
 * - explicit false/true from website settings wins
 * - if unset, same as before: REACT_APP_CAPTCHA !== "false"
 */
export const isCaptchaEnabled = (
    siteValue: unknown,
    envValue: string | undefined = process.env.REACT_APP_CAPTCHA
) => {
    if (siteValue === false) return false;
    if (siteValue === true) return true;
    return envValue !== "false";
};

export const formatTwoDecimal = (value: any) => {
    const num = Number(value);
    return Number.isFinite(num) ? num.toFixed(2) : "0.00";
};
